import {
  Container,
  Grid,
  Icon,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import {
  EditOutlined,
  FileCopyOutlined,
  DeleteOutlined,
} from "@material-ui/icons";
import { useContext, useEffect, useState } from "react";
import Btn from "../../../../components/buttons/Btn";
import Card from "../../../../components/cards/Card";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import { Margin } from "../../../financeiro/nfe/styles/Emissao";

import ContractsController from "../controller/ContractsController";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { useHistory } from "react-router-dom";
import BigDataTable from "../../../../components/tables/BigDataTable";
import TextField from "../../../../components/basics/TextFieldErp";
import RedBall from "../../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../../assets/imgs/bolinha-verde.png";
import { BallContainer } from "../styles/Modals";

let typingTimer = null;
export default function ModalContractsListagem() {
  const { queryParams } = useContext(QueryParamsContext);
  const { push } = useHistory();
  const { destroy, handleCloneModel } = ContractsController();
  const [queryOrWhere, setQueryOrWhere] = useState(null);
  const [queryWhere, setQueryWhere] = useState({ ativo: "" });
  const [reload] = useState(false);
  const [textFilter, setTextFilter] = useState("");
  const [showOnlyActives, setShowOnlyActives] = useState(true);

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setQueryOrWhere({
        descricao: encodeURIComponent(`${textFilter}`),
      });
    }, 1500);
  }, [textFilter]);

  useEffect(() => {
    setQueryWhere({ ativo: showOnlyActives ? "S" : "N" });
  }, [showOnlyActives]);

  const handleDelete = async (id) => {
    if (id) await destroy(id);
    setQueryWhere({ ativo: showOnlyActives ? "S" : "N" });
  };

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        let itemActions = [
          {
            icon: <EditOutlined />,
            name: "Editar",
            action: () =>
              push(
                "cadastro?empresa_cnpj=" +
                  queryParams.empresa_cnpj +
                  "&empresa_id=" +
                  queryParams.empresa_id,
                { item }
              ),
          },
          {
            icon: <FileCopyOutlined />,
            name: "Clonar",
            action: () => handleCloneModel({ item }),
          },
          {
            icon: <DeleteOutlined />,
            name: "Excluir",
            action: () => handleDelete(item.id),
            disabled: item.id === 1,
          },
        ];

        return <SpeedDialErp actions={itemActions} />;
      },
    },
    {
      label: "Descrição",
      align: "left",
      format: (value) => {
        return value?.descricao;
      },
      disablePadding: false,
    },
    {
      id: "ativo",
      label: "Ativo",
      align: "center",
      format: (value) =>
        value.ativo === "S" ? (
          <BallContainer>
            <img src={GreenBall} alt="ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="inativo" />
          </BallContainer>
        ),
    },
  ];

  return (
    <>
      <Margin top={80}>
        <Container maxWidth="xl">
          <Grid item container spacing={1}>
            <Card fullWidth={true}>
              <Grid item container xs spacing={1}>
                <Grid
                  item
                  container
                  xs={12}
                  spacing={2}
                  alignItems="flex-end"
                  justifyContent="space-between"
                >
                  <Grid item xs={12} sm={12} md={7}>
                    <TextField
                      value={textFilter}
                      setValue={setTextFilter}
                      label="Busque por Descrição"
                      variant="filled"
                    />
                  </Grid>
                  <Grid item xs></Grid>
                  <Grid item xs={6} sm={6} md={3} lg={3}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={showOnlyActives}
                          onChange={() =>
                            setShowOnlyActives((current) => !current)
                          }
                          color="primary"
                        />
                      }
                      label="Ativos"
                      labelPlacement="end"
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Btn
                      label="NOVO"
                      onClick={() =>
                        push(
                          "cadastro?empresa_cnpj=" +
                            queryParams.empresa_cnpj +
                            "&empresa_id=" +
                            queryParams.empresa_id
                        )
                      }
                      startIcon={<Icon>add</Icon>}
                      full="true"
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <BigDataTable
                    tableTitle=""
                    route={
                      "faturamento/contrato-modelo/v1/por-empresa/" +
                      queryParams.empresa_id
                    }
                    fields={{
                      "faturamento.contratos_modelos": "id,descricao,ativo",
                    }}
                    columns={columns}
                    where={queryWhere}
                    orWhere={queryOrWhere}
                    reload={reload}
                    fixedSort={"id"}
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Container>
      </Margin>
    </>
  );
}
